import { serviceRequest } from 'utils/http';
import { StudySitePerformanceService } from 'common/api';

type GetStudySitePerformance = {
  studyId: string;
  siteId: string;
};

export function getStudySitePerformanceAPI({
  studyId,
  siteId,
}: GetStudySitePerformance) {
  return serviceRequest(() =>
    StudySitePerformanceService.studySitePerformanceControllerGet(
      studyId,
      siteId
    )
  );
}
